HumanizeFilter.$inject = ['_', 'CONST'];

function HumanizeFilter(_, CONST) {
    const contexts = {
        'default': function (value) {
            if (value === true) {
                return 'Sí';
            } else if (value === false) {
                return 'No';
            }
            return value;
        },
        'payment_type': {
            'cash': 'Efectivo',
            'credit_card': 'Crédito',
            'debit_card': 'Débito',
            'mercado_pago': 'Mercado Pago',
            'check': 'Cheque',
            'transfer': 'Transferencia',
        },
        'general_cash_movement_type': {
            'deposit': 'Venta',
            'extraction': 'Compra',
        },
        'cash_movement_type': {
            'deposit': 'Ingreso Seña',
            'extraction': 'Egreso Seña',
            'deposit-online': 'Seña Autorización',
            'extraction-online': 'Egreso Seña',
            'done': 'done',
            'cancelled': 'cancelled',
            'reported': 'reported',
            'court_updated': 'court_updated',
        },
        'booking_type': function (id, args) {
            const type = CONST.bookings.types[id];
            if (type && args) {
                return type[args];
            }
            return type;
        }
    };

    return function (value, context = 'default', args = undefined) {
        const handler = contexts[context];
        return _.isFunction(handler) ? handler(value, args) : handler[value];
    };
}

export default HumanizeFilter;